var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNestmateSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 38.4716V75.105C0 76.812 2.09864 77.7311 3.27912 76.4181L53.2529 25.9979C66.3694 12.7363 88.5362 18.3824 94.1763 35.583C94.5698 36.7647 95.3568 37.8151 96.2749 38.6029L104.407 45.0368C105.588 45.9559 105.588 47.7941 104.407 48.7132L100.079 52.1271C98.3736 53.4401 97.4554 55.6723 97.5866 57.7731C98.8982 79.9632 94.4386 102.153 84.2078 122.243C83.5519 123.556 84.4701 125 85.9129 125H86.5687C107.817 125 125 107.799 125 86.5284V38.4716C125 17.2006 107.817 0 86.5687 0H38.4313C17.1826 0 0 17.2006 0 38.4716Z",
    fill: "#FF9A3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.174 53.3088C82.0134 53.3088 85.1258 50.1932 85.1258 46.3498C85.1258 42.5064 82.0134 39.3908 78.174 39.3908C74.3347 39.3908 71.2223 42.5064 71.2223 46.3498C71.2223 50.1932 74.3347 53.3088 78.174 53.3088Z",
    fill: "#FF9A3D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNestmateSymbol);
export default __webpack_public_path__ + "static/media/nestmate-symbol.32bf922cc7bf9aaa926c9b87f5ef2e1c.svg";
export { ForwardRef as ReactComponent };